<section class="full-height flex-column">
  <vdw-header [title]="'TEXTILE_DATA.FIXED_ORDER.FIXED_ORDER' | bmsTranslate: {count: 2}" svgIcon="select-blue" [canShowClose]="true"></vdw-header>

  <article class="dialog-content flex-grow">
    <ag-grid-angular class="ag-theme-vdw" [gridOptions]="listOfGridOptions[0]" [rowData]="listOfFixedSchedules()"></ag-grid-angular>
  </article>

  <vdw-footer chooseEventName="GENERAL.ACTIONS.ADD" [centered]="true" [withCancelButton]="false" (chooseEvent)="confirmSelection()"></vdw-footer>
</section>
